import React from "react";

import { validate } from "email-validator";
import { Button, FormControl } from "react-bootstrap";

import { empty, isValid as isValidPassword } from "@helpers/passwordValidation";
import { PasswordValidation } from "@legacyComponents/login/PasswordValidation";
import { InvitationSignUpForm } from "./InvitationSignUpForm";

import "./InvitationSignUp.scss";

interface Props {
  isAdvancedSecurity: boolean;
  email: string;
  password?: string;
  passwordConfirmation?: string;
  passwordLength: number;
}

interface State {
  email?: string;
  emailError?: string;
  password?: string;
  passwordConfirmation?: string;
  isValidEmail?: boolean;
}

interface EmailFieldValidity {
  emailError: string;
  isValidEmail: boolean;
}

class InvitationSignUp extends React.Component<Props, Readonly<State>> {
  constructor(props: Props) {
    super(props);

    const { email, password, passwordConfirmation } = props;

    this.state = {
      email: email === null ? "" : email,
      password: password === null ? "" : password,
      passwordConfirmation: passwordConfirmation === null ? "" : passwordConfirmation,
    };
  }

  componentDidMount() {
    this.validateEmailField(this.state.email);
  }

  handleEmailChanged = (event: React.ChangeEvent<FormControl.FormControlProps>) => {
    const value: string = event.currentTarget.value as string;
    this.setState({ email: value });
    this.validateEmailField(value);
  };

  handlePasswordChanged = (event: React.ChangeEvent<FormControl.FormControlProps>) => {
    const {
      currentTarget: { value },
    } = event;
    this.setState({ password: value as string });
  };

  handlePasswordConfirmationChanged = (event: React.ChangeEvent<FormControl.FormControlProps>) => {
    const {
      currentTarget: { value },
    } = event;
    this.setState({ passwordConfirmation: value as string });
  };

  isEmailFieldValid = (email: string): EmailFieldValidity => {
    if (empty(email)) {
      return {
        emailError: "This field is required.",
        isValidEmail: false,
      };
    } else if (!validate(email)) {
      return {
        emailError: "This email is invalid.",
        isValidEmail: false,
      };
    } else {
      return {
        emailError: null,
        isValidEmail: true,
      };
    }
  };

  validateEmailField = (email: string) => {
    this.setState(this.isEmailFieldValid(email));
  };

  render() {
    const { isAdvancedSecurity, passwordLength } = this.props;
    const { email, emailError, password, passwordConfirmation, isValidEmail } = this.state;

    const validPasswords = isValidPassword(
      password,
      passwordConfirmation,
      passwordLength,
      isAdvancedSecurity
    );
    const isValid = validPasswords.isValid && isValidEmail;

    return (
      <>
        <InvitationSignUpForm
          email={email}
          emailError={emailError}
          password={password}
          passwordConfirmation={passwordConfirmation}
          onEmailChanged={this.handleEmailChanged}
          onPasswordChanged={this.handlePasswordChanged}
          onPasswordConfirmationChanged={this.handlePasswordConfirmationChanged}
          isValidEmail={isValidEmail}
        />
        <PasswordValidation
          isAdvancedSecurity={isAdvancedSecurity}
          passwordLength={passwordLength}
          {...validPasswords}
        />
        <Button
          bsStyle="primary"
          type="submit"
          className="invitation-sign-up-button--large"
          disabled={!isValid}
        >
          Create Account
        </Button>
      </>
    );
  }
}

export { InvitationSignUp };
